import { render, staticRenderFns } from "./SectionTitleAndHelpAccordion.vue?vue&type=template&id=308d8532&scoped=true&"
import script from "./SectionTitleAndHelpAccordion.vue?vue&type=script&lang=js&"
export * from "./SectionTitleAndHelpAccordion.vue?vue&type=script&lang=js&"
import style0 from "./SectionTitleAndHelpAccordion.vue?vue&type=style&index=0&id=308d8532&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "308d8532",
  null
  
)

export default component.exports